module.exports = __webpack_public_path__ + "img/soy_allergy-off.f658d960.svg";